const adminPanel = {
  adminPanel: {
    einInstallerSetup: 'Configuration de l’installateur EIN',
    installerDataUpdate: 'Mise à jour des données de l’installateur',
    uploadFile: 'Charger un fichier',
    chooseFile: 'Choisir un fichier',
    installerDataUpdateDescription:
      'Part de marché de l’installateur Enphase, informations du principal promoteur etc.',
    header: 'Liens de la barre d’en-tête',
    platinumTier: 'Niveau Platine',
    goldTier: 'Niveau Or',
    silverTier: 'Niveau Argent',
    same: 'Identique pour tous les niveaux',
    bannerDescription: 'Description de la bannière',
    bannerLink: 'Lien de la bannière',
    digitalAssets: 'Actifs numériques',
    name: 'Nom',
    file: 'Fichier',
    access: 'Accès à la catégorie de niveau',
    action: 'Action',
    all: 'Tous',
    platinum: 'Platinum',
    gold: 'Gold',
    silver: 'Silver',
    addDigital: 'Tous les actifs numériques',
    productInformation: 'Informations sur le produit',
    productName: 'Nom du produit',
    learnMoreLink: 'Lien En savoir plus',
    featureName: 'Nom de la fonctionnalité A/B',
    featureType: 'Type de fonctionnalité',
    betaRelease: 'Date de la sortie bêta',
    addProduct: 'Ajouter des informations sur le produit',
    exclusiveUpdate: 'Liens de mise à jour exclusive',
    description: 'Description',
    link: 'Lien',
    addLink: 'Ajouter un lien',
    one: '1.',
    two: '2.',
    installerList: 'Liste des installateurs pour l’accès au produit',
    usa: 'États-Unis',
    // TODO - Start
    usa_pr: 'USA - Puerto Rico',
    // TODO - End
    australia: 'Australie',
    belgium: 'Belgique',
    netherlands: 'Pays-Bas',
    germany: 'Allemagne',
    india: 'Inde',
    mexico: 'Mexique',
    country: 'Pays',
    fileName: 'Nom du fichier',
    software_service: 'SOFTWARE_SERVICE',
    hardware_product: 'HARDWARE_PRODUCT',
    empty_file: 'Le fichier est vide',
    invalidFileFormat: 'Format de fichier invalide',
    invalidFileHeader: 'En-tête de fichier invalide',
    uploadFailed: 'Échec du chargement du fichier',
    invalidFile: 'Fichier invalide',
    errorDetail: {
      one: '%{errorCount} sur %{count} ligne ont un défaut.',
      other: '%{errorCount} sur %{count} lignes ont un défaut.'
    },
    viewError: 'Voir les erreurs',
    errorListText: 'Liste des erreurs de chargement de fichier',
    companyId: 'Identifiant de la société',
    message: 'Message',
    sampleFileName: 'Exemple de fichier'
  }
};

export default adminPanel;
